import { jsxAsElement as jsx } from 'web-shared/src/lib/jsx';
import { makeApiRequest, skeleton } from '../old/utils';

export class CatCount extends HTMLElement {
  expectedDigits: number = 4;

  constructor() {
    super();
  }

  getStats = async (): Promise<number> => {
    const response = await makeApiRequest<{ count: number }>(
      '/goatcounter/count',
      'GET',
    );

    return response.count;
  };

  renderCount = async () => {
    this.innerHTML = '';
    this.append(skeleton(`${this.expectedDigits * 35}px`, '75px'));

    const count = await this.getStats();

    this.innerHTML = '';
    this.append(
      <div className="catCounter">
        {...count
          .toString()
          .replaceAll(' ', '')
          .split('')
          .map((char) => <img alt={char} src={`/cat-count/${char}.gif`} />)}
      </div>,
    );
  };

  connectedCallback() {
    void this.renderCount();
  }
}
